// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 550 ? "ed48eaa7" : chunkId) + "." + {"550":"85c3c9aea662c345","794":"e929ac23339b835d"}[chunkId] + ".js";
};